import { DocumentUpload } from '../../components/upload';

export default DocumentUpload;
